import {validateRecordCell} from '@/main-page/gridCellEditor/validate/validateRecordCell';
import {useColumnRequired} from '@/main-page/gridCellEditor/validate/columnRequired';

export function useEditorValidate({emits, validate, column, record, index}: any) {
  const hasError = ref(false);
  const errorMsg = ref('');
  const {getState} = useColumnRequired();

  const emitValidateFlag = (flag: boolean, msg = '') => {
    if (!emits) {
      return;
    }
    const col = unref(column);
    const fieldKey = col.dataIndex || col.propId;
    emits('initValidateFlag', {
      itemId: fieldKey,
      flag,
      msg,
      errorMsg: msg,
      rowIndex: unref(index),
      fieldName: fieldKey,
      fieldLabel: col.propName || col.title || fieldKey,
    });
  };

  const validateAll = function () {
    const error = validateRecordCell({
      record: unref(record),
      column: unref(column),
      rowIndex: unref(index),
      state: getState,
    });
    if (error) {
      hasError.value = true;
      errorMsg.value = error.msg;
      emitValidateFlag(true, error.msg);
      return;
    }
    hasError.value = false;
    errorMsg.value = '';
    emitValidateFlag(false);
  }

  const clearError = () => {
    hasError.value = false;
    errorMsg.value = '';
    emitValidateFlag(false);
  };

  if (validate) {
    watch(validate, () => {
      const scope = unref(validate);
      if (scope && typeof scope === 'object' && Array.isArray(scope.recordIds)) {
        const rowId = unref(record)?.id;
        const inScope = rowId != null && rowId !== '' && scope.recordIds.includes(String(rowId));
        if (!inScope) {
          clearError();
          return;
        }
      }
      validateAll();
    })
  }

  return {
    validateAll,
    hasError,
    errorMsg
  }
}
